import { createRESTContract } from '../../index';
import { SyncBodySchema } from '../data-sources/sync.schema';
import {
  DownloadSharepointFileSchema,
  SyncSharepointResponseSchema,
} from './sharepoint.schema';

export const sharepointContract = createRESTContract({
  sync: {
    method: 'POST',
    path: '/sharepoint/sync',
    permissions: [],
    body: SyncBodySchema,
    response: SyncSharepointResponseSchema,
  },
  downloadFile: {
    method: 'GET',
    path: '/sharepoint/files/download/:id',
    permissions: [],
    response: DownloadSharepointFileSchema,
  },
});
